// Onboarding (F2) — 4-status state-machine voor Onboarding-traject.
//
// Bron-hiërarchie:
//   - Status-overgangen uit `apps/api/src/routes/onboarding.ts` en
//     `packages/utils/src/onboarding-helpers.ts`.
//   - Spec § "Status workflow": CONCEPT → IN_BEHANDELING → AFGEROND.
//   - GEANNULEERD vanuit CONCEPT/IN_BEHANDELING als HR het traject afbreekt.
//
// Workflow:
//   CONCEPT → IN_BEHANDELING → AFGEROND
//   * → GEANNULEERD  (HR breekt af)
//   AFGEROND en GEANNULEERD zijn eindstaten.

import { WorkflowEngine, type WorkflowDefinition } from '../workflow-engine'

/** Mirror van Prisma OnboardingStatus enum. */
export type OnboardingWorkflowStatusValue =
  | 'CONCEPT'
  | 'IN_BEHANDELING'
  | 'AFGEROND'
  | 'GEANNULEERD'

export const onboardingWorkflow: WorkflowDefinition<OnboardingWorkflowStatusValue> =
  {
    name: 'onboarding',
    initial: 'CONCEPT',
    states: ['CONCEPT', 'IN_BEHANDELING', 'AFGEROND', 'GEANNULEERD'],
    transitions: [
      // 1. HR start het traject — start eerste stap activeert auto-promotie naar IN_BEHANDELING
      {
        from: 'CONCEPT',
        to: 'IN_BEHANDELING',
        label: 'Starten',
        rolesAllowed: ['HR', 'ADMIN'],
      },
      // 2. Alle stappen afgerond → AFGEROND (Employee.status wordt ACTIEF)
      {
        from: 'IN_BEHANDELING',
        to: 'AFGEROND',
        label: 'Afronden',
        rolesAllowed: ['HR', 'ADMIN'],
      },
      // 3. HR breekt af vanuit elke open status
      {
        from: 'CONCEPT',
        to: 'GEANNULEERD',
        label: 'Annuleren',
        rolesAllowed: ['HR', 'ADMIN'],
      },
      {
        from: 'IN_BEHANDELING',
        to: 'GEANNULEERD',
        label: 'Annuleren',
        rolesAllowed: ['HR', 'ADMIN'],
      },
    ],
  }

/** Engine-instance voor onboarding — direct importeerbaar in API-routes. */
export const onboardingEngine = new WorkflowEngine(onboardingWorkflow)
